import { Listing } from '@root/types';
import { Typography } from 'antd';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ts from '@styles/typography.module.less';
import routes from '@root/routes';
import ActionButtons from './ActionButtons';
import s from './ListingLocation.module.less';

const { Title } = Typography;

type Props = { listing: Listing };

const ListingLocation = ({ listing }: Props) => {
  const {
    building: {
      primaryName: buildingPrimaryName,
      secondaryName: buildingSecondaryName,
      neighborhood: buildingNeighborhood,
      cityLocalityRegion: buildingCityLocalityRegion,
      countryCode: buildingCountryCode,
      crossStreets: buildingCrossStreets,
      slug: buildingSlug,
    },
    name: listingName,
  } = listing;
  const { t } = useTranslation('listing');

  const linkToBuildingPage = routes.building(buildingSlug);

  const renderBuildingCityDetails = () => {
    const cityDetails = buildingCityLocalityRegion;
    const cityWithNeighborhood = cityDetails && buildingNeighborhood;
    return (
      <>
        <div className={s.secondaryInfo}>
          {cityWithNeighborhood ? (
            <>
              <Link to={linkToBuildingPage}>
                <Title className={s.secondaryInfo} level={2}>
                  {buildingNeighborhood}
                </Title>
              </Link>
              <figure className={s.line}></figure>
            </>
          ) : null}
          <Link to={linkToBuildingPage}>
            <Title className={s.secondaryInfo} level={2}>
              {buildingCityLocalityRegion}
            </Title>
          </Link>
        </div>
        <Link to={linkToBuildingPage}>
          <Title className={s.secondaryInfo} level={2}>
            {t(`country:${buildingCountryCode}`)}
          </Title>
        </Link>
      </>
    );
  };

  return listing.hideLocation ? (
    <div className={s.container}>
      <div className={s.locationAndActionButtons}>
        {listing.building.photo ? (
          <div className={s.buildingPhoto}>
            <img alt={listing.building.photo.description} src={listing.building.photo.smallPath} />
          </div>
        ) : null}
        <div className={s.spacer} />
      </div>
      <h1 className={s.neighborhoodTitle}>
        {t('location.neighborhoodInShare', { neighborhood: buildingNeighborhood })}
      </h1>
      {listing.status === 'off_market' ? (
        <div className={s.offMarketLabel}>{t('offMarket')}</div>
      ) : null}
    </div>
  ) : (
    <div className={s.container}>
      <div className={s.locationAndActionButtons}>
        {listing.building.photo ? (
          <Link className={s.buildingPhoto} to={linkToBuildingPage}>
            <img alt={listing.building.photo.description} src={listing.building.photo.smallPath} />
          </Link>
        ) : null}
        <div className={s.spacer} />
        <ActionButtons listing={listing} />
      </div>
      <Link to={linkToBuildingPage}>
        <Title level={1} className={s.primaryInfo}>
          {buildingPrimaryName}
        </Title>
      </Link>

      <Link to={linkToBuildingPage}>
        <Title level={1} className={s.primaryInfo}>
          {buildingSecondaryName}
        </Title>
      </Link>
      <Link to={linkToBuildingPage}>
        <Title level={2} className={s.secondaryInfo}>
          {listingName}
        </Title>
      </Link>
      {renderBuildingCityDetails()}
      {buildingCrossStreets ? (
        <div className={ts.bodySmallRegular}>
          {t('crossStreets', { crossStreets: buildingCrossStreets })}
        </div>
      ) : null}
      {listing.status === 'off_market' ? (
        <div className={s.offMarketLabel}>{t('offMarket')}</div>
      ) : null}
    </div>
  );
};

export default ListingLocation;
